import { Container, ContainerProps, Flex, Text, Img } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
interface IContentNotFound extends ContainerProps {
  infoType?: 'notFound' | 'serverSideError'
}

const ContentNotFound = ({
  infoType = 'notFound',
  ...rest
}: IContentNotFound) => {
  const { t } = useTranslation()
  return (
    <Container
      as="section"
      minHeight="75vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      {...rest}
    >
      <Img
        maxWidth={{ base: '300px', lg: '300px' }}
        src={
          infoType === 'serverSideError'
            ? '/img/not-found/server-down.png'
            : '/img/not-found/art-collection-not-found.png'
        }
      />
      <Text
        color="black.primary4"
        fontWeight="light"
        fontSize="xl"
        textAlign="center"
      >
        {t(
          infoType === 'notFound'
            ? 'common:contentNotFoundProgramTitle'
            : 'common:contentNotFound'
        )}
      </Text>
      {infoType === 'notFound' && (
        <Flex flexDirection="column" alignItems="center">
          <Text fontSize="sm" textAlign="center">{t('common:contentNotFoundProgramDesc')}</Text>
        </Flex>
      )}
    </Container>
  )
}

export default ContentNotFound
